import {gql} from '@apollo/client';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {assertIsAccessible} from 'graphql-client/InaccessibleInfo';

import {StorableSummaryGraphQL} from '../../../../graphql-fragments/inventory/__generated/StorableSummaryGraphQL';
import {StorableSummaryQuery, StorableSummaryQueryVariables} from './__generated/StorableSummaryQuery';

export const STORABLE_SUMMARY_QUERY = gql`
  query StorableSummaryQuery($id: StrictString!) @engComponent(name: INVENTORY) @skipAudit {
    storable(id: $id) {
      ...StorableSummaryGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('StorableSummary').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function useSkippableStorableSummaryQuery(id: string | null): StorableSummaryGraphQL | null {
  const response = useSkippableBenchlingQuery<StorableSummaryQuery, StorableSummaryQueryVariables>(
    STORABLE_SUMMARY_QUERY,
    {skip: id == null, variables: {id: id!}}
  );

  if (response.type !== QueryResultType.SUCCESS) {
    return null;
  }

  return assertIsAccessible(response.data.storable);
}
